import React, {useEffect, useState} from "react";
import {Alert, Button, Icon, Spacer, SubTitle, Text, Theme, ThirdTitle, Toggle} from "@dspworkplace/ui";
import Modal, {useModal} from "../../../../components/Modal";
import Loading, {LoadingWrapper} from "../../../../components/Loading";
import PaycomSettingsV2 from "./paycom_v2";
import ADPSettingsV2 from "./adp_v2";
import DSPSettings from "./dsp";
import UzioSettingsV2 from "./uzio_v2";
import {confirm} from '../../../../components/Confirm';
import apiFactory from "../../../../api/factory";
import {useIntersection} from '../../../../hooks/useIntersect'
import {ButtonIcon, Card} from "../../../../components/UI";
import {toast} from "../../../../components/Toasts";
import Tooltip from "../../../../components/Tooltip";
import Skeleton from "../../../../components/Skeleton"

const PAYROLL_TYPE_ADP = 'ADP';
const PAYROLL_TYPE_ADP_LEGACY = 'ADP_LEGACY';
const PAYROLL_TYPE_PAYCOM = 'PAYCOM';
const PAYROLL_TYPE_DSP = 'DSP';
const PAYROLL_TYPE_UZIO = 'UZIO';

const {call, cancel} = apiFactory();


export default function PayrollSettings() {
    const [visible, toogleModal] = useModal(false);
    const [loading, setLoading] = useState(false);
    const [payrollType, setPayrollType] = useState(false)
    const [data, setData] = useState([])
    const [meta, setMeta] = useState({page: 0, totalPages: 0})
    const [initialValues, setInitialValues] = useState(false)

    const [error, setError] = useState('')


    const getList = async (page = 1) => {
        //only to close the modal on callback
        if (visible) toogleModal(false)

        setLoading(true)
        const res = await call(null, `/api/v2/payroll_account?enabledOnly=false&limit=20&page=${page}`, 'get')
        setData(data => {
            if (page === 1) return res.data.data;

            return [...data, ...res.data.data]
        })
        setMeta({page: res.data.meta.page, totalPages: Math.ceil(res.data.meta.total / res.data.meta.limit)})
        setLoading(false)
    }

    useEffect(() => {
        getList()
    }, [])

    useEffect(()=>{
        if(visible) return
        setError('')
    },[visible])

    const LoaderRef = React.useRef(null);
    const entry = useIntersection(LoaderRef, {
        threshold: 0.05,
    });
    const isLoadingVisible = !!entry?.isIntersecting;

    useEffect(() => {
        if (isLoadingVisible && meta.page < meta.totalPages) {
            getList(meta.page + 1)
        }
    }, [isLoadingVisible]);

    const onSubmit = async (data) => {
        setLoading(true)
        setError('');

        if (data.id) {
            
            const hasError = await call(data, `/api/v2/payroll_account/${data.id}`, 'put')
            .then(r => null)
            .catch(e => {
                const err = e.response?.data?.errors?.[0] ?? e?.response?.data?.message
                setError(err)
                return !!err
            })
            if (hasError) {
                setLoading(false)
                 throw new Error();
            }

        } else {
            delete data.id
            const hasError = await call(data, `/api/v2/payroll_account`)
            .then(r => null)
            .catch(e => {
                console.log('e',e.response)
                const err = e.response?.data?.errors?.[0]?.message ?? e?.response?.data?.message
                setError(err)
                return !!err
            })

            if (hasError) {
                setLoading(false)
                throw new Error();
            }
        }
    
        getList(1)
    }

    return (
        <>
            <Spacer style={{position: 'relative'}}>
                {loading && <LoadingWrapper><Loading/></LoadingWrapper>}

                <SubTitle>Payroll Settings</SubTitle>

                <Text>Create and manage your payroll settings.</Text>
                <Spacer top={5}/>

                <div style={{
                    display: "grid",
                    gridTemplateColumns: "repeat( auto-fit, calc(50% - 10px))",
                    gridColumnGap: 20,
                    gridRowGap: 20,
                }}>
                    {data?.map(payroll => (
                        <PayrollCard
                            key={payroll.name + payroll.integration_type}
                            payroll={payroll}
                            setInitialValues={setInitialValues}
                            setLoading={setLoading}
                            setPayrollType={setPayrollType}
                            toogleModal={toogleModal}
                            getList={getList}
                        />
                    ))}

                    <Card style={{position: 'relative'}}>
                        <Skeleton height={12} width={140} animation/>
                        <Spacer top={3} bottom={5} style={{display: 'flex'}}>
                            <Skeleton height={28} width={100} animation/>
                            <Spacer inline style={{flexGrow: '1'}}/>
                            <Skeleton height={20} width={32} animation/>
                            <Spacer inline left={2}/>
                            <Skeleton height={20} width={20} animation/>
                            <Spacer inline left={2}/>
                            <Skeleton height={20} width={20} animation/>
                            <Spacer inline left={2}/>
                            <Skeleton height={20} width={20} animation/>
                        </Spacer>
                        <Skeleton height={16} width={180} animation/>
                        <Spacer bottom={1}/>
                        <Skeleton height={16} width={300} animation/>
                        <div style={{
                            position: "absolute",
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }}>
                            <Button type='primary' onClick={() => {
                                toogleModal(true)
                            }}>
                                Add Payroll Account
                            </Button>
                        </div>
                    </Card>
                </div>

                <Modal
                    title={"Add Payroll Account"}
                    width='800px'
                    visible={visible}
                    setVisible={() => {
                        setPayrollType(false)
                        toogleModal(false);
                    }}
                    
                >
                    {!payrollType &&
                        <div style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "normal",
                            gap: 20,
                        }}>
                            <Button
                                onClick={() => {
                                    setInitialValues(false);
                                    setPayrollType(PAYROLL_TYPE_ADP)
                                }}
                                style={{
                                    height: "auto",
                                    padding: 12,
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <img src="/adp.png" alt={'ADP'} width={100}/>
                            </Button>
                            <Button
                                onClick={() => {
                                    setInitialValues(false);
                                    setPayrollType(PAYROLL_TYPE_PAYCOM)
                                }}
                                style={{
                                    height: "auto",
                                    padding: 12,
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <img src="/paycom.png" alt={'Paycom'} width={100}/>
                            </Button>
                            <Button
                                onClick={() => {
                                    setInitialValues(false);
                                    setPayrollType(PAYROLL_TYPE_UZIO);
                                }}
                                style={{
                                    height: "auto",
                                    padding: 12,
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <img src="/uzio.png" alt={'Uzio'} width={100} />
                            </Button>
                            <Button
                                onClick={() => {
                                    setInitialValues(false);
                                    setPayrollType(PAYROLL_TYPE_DSP)
                                }}
                                style={{
                                    height: "auto",
                                    padding: 12,
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <img src="/512x512.png" alt={'DSP'} width={100}/>
                            </Button>
                        </div>
                    }

                    {payrollType === PAYROLL_TYPE_ADP &&
                        <>
                            <ThirdTitle>ADP Marketplace Connector</ThirdTitle>
                            <Spacer bottom={3}/>
                            <ADPSettingsV2 initialValues={initialValues} onSubmit={onSubmit}/>
                        </>
                    }

                    {payrollType === PAYROLL_TYPE_PAYCOM &&
                        <>
                            <ThirdTitle>Paycom API integration</ThirdTitle>
                            <Spacer bottom={3}/>
                            <PaycomSettingsV2 initialValues={initialValues} onSubmit={onSubmit}/>
                        </>
                    }

                    {payrollType === PAYROLL_TYPE_UZIO && (
                        <>
                            <ThirdTitle>Uzio API integration</ThirdTitle>
                            <Spacer bottom={3} />
                            <UzioSettingsV2 initialValues={initialValues} onSubmit={onSubmit} />
                        </>
                    )}

                    {payrollType === PAYROLL_TYPE_DSP &&
                        <>
                            <ThirdTitle>DSP API integration</ThirdTitle>
                            <Spacer bottom={3}/>
                            <DSPSettings initialValues={initialValues} onSubmit={onSubmit}/>
                        </>
                    }

                    {error && <div style={{marginTop: 40}}>
                        <Alert.Error
                            title='Something is wrong'
                            content={error}
                        />
                    </div>}
                </Modal>

            </Spacer>
            <div
                style={{marginBottom: 30, visibility: meta.page < meta.totalPages ? "visible" : "hidden"}}
                ref={LoaderRef}
            >
                {data.length > 0 && (
                    <Loading style={{width: "40px", margin: "30px auto", display: "block", paddingBottom: 30}}/>
                )}
            </div>
        </>
    )
}

const PayrollCard = ({payroll, setInitialValues, setLoading, setPayrollType, toogleModal, getList}) => {
    const handleChangeStatus = async (e, payroll) => {
        await call({
            payroll_id: payroll.id,
            enabled: e.target.checked
        }, `/api/v2/payroll_account/${payroll.id}/status`, 'put')
            .then(r => {
                getList();
            })
            .catch(e => {
                const err = e.response?.data?.errors?.[0] ?? e?.response?.data?.message
                return !!err
            });
    }

    const handleEdit = (initialValues, payroll) => {
        if (payroll === PAYROLL_TYPE_PAYCOM) {
            initialValues.clientId = initialValues.credentials.username
            initialValues.clientSecret = initialValues.credentials.password
        }

        if (payroll === PAYROLL_TYPE_ADP) {
            initialValues.connectorCode = initialValues.credentials.connector_code
            initialValues.uniqueAccountIdentifier = initialValues.credentials.unique_identifier
        }

        setInitialValues(initialValues)
        setPayrollType(payroll)
        toogleModal(true)
    }


    const handleArchive = async (payrollId) => {
        let r = await confirm({
            icon: true,
            title: 'Are you sure you want to remove this payroll account?',
            text: 'Previously imported data will not be removed, such as employees or punch times'
        });
        if (!r) {
            return;
        }
        setLoading(true)
        const res = await call(null, `/api/v2/payroll_account/${payrollId}`, 'delete').catch(e => {
            const err = e.response?.data?.errors?.[0] ?? e?.response?.data?.message
            return {error: err}
        })

        if (res?.data?.archive) {
            await getList(1)
            return
        }
        setLoading(false)

        toast({
            type: "error",
            title: "Something goes wrong",
            content: res.error
        });
    }

    const handlePrimaryAccount = async (payrollId, payrollType) => {
        payrollType = payrollType.replace('_', ' ')
        let r = await confirm(`All others account from ${payrollType} will set primary to false, are you sure?`);
        if (!r) {
            return;
        }

        setLoading(true)
        const res = await call(null, `/api/v2/payroll_account/${payrollId}/primary`, 'put')
        if (res?.data?.id) {
            await getList(1)
            return
        }
        setLoading(false)
    }

    return (
        <Card>
            <Text style={{
                color: Theme.colors.neutrals.medium,
                display: 'inline-flex',
                alignItems: 'center',
                gap: 4,
                fontSize: Theme.font.extraSmall.size,
                lineHeight: Theme.font.extraSmall.lineHeight,
            }}>
                 {payroll.integrationType === PAYROLL_TYPE_DSP &&
                    <>
                        <img src="/512x512.png" alt={''} height={12}/>
                        <span>DSP Settings</span>
                    </>}
                {payroll.integrationType === PAYROLL_TYPE_ADP &&
                    <>
                        <img src="/adp.png" alt={''} height={12}/>
                        <span>ADP Marketplace Connector</span>
                    </>}
                {payroll.integrationType === PAYROLL_TYPE_PAYCOM &&
                    <>
                        <img src="/paycom.png" alt={''} height={12}/>
                        <span>Paycom API Integration</span>
                    </>}
                {payroll.integrationType === PAYROLL_TYPE_UZIO && (
                    <>
                        <img src="/uzio.png" alt={''} height={12}/>
                        <span style={{ fontWeight: 700 }}>Uzio API Integration</span>
                    </>
                )}
            </Text>
            <Spacer bottom={3}/>

            <Spacer
                bottom={5}
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <SubTitle>{payroll.name}</SubTitle>

                <div style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 8,
                }}>
                    <Toggle
                        onChange={(e) => handleChangeStatus(e, payroll)}
                        on={payroll.enabled}
                    />
                    <Tooltip
                        content={`
                            ${payroll.main ? 'Current primary account' : 'Set as primary account'}: 
                            When you have multiple payrolls from the same type, the 
                            primary account it will be used as main source of data
                        `}
                    >
                        <ButtonIcon
                            title={'Set as primary account'}
                            icon={Icon.Flag}
                            color={payroll.main ? Theme.colors.success.text : Theme.colors.neutrals.silver}
                            onClick={() => handlePrimaryAccount(payroll.id, payroll.integrationType)}
                        />
                    </Tooltip>
                    <ButtonIcon
                        title={'Edit account'}
                        icon={Icon.Edit}
                        onClick={() => handleEdit(payroll, payroll.integrationType)}
                    />
                    <ButtonIcon
                        title={'Remove account'}
                        icon={Icon.Trash}
                        color={Theme.colors.error.text}
                        onClick={() => handleArchive(payroll.id)}
                    />
                </div>
            </Spacer>

            {(() => {
                switch (payroll.integrationType) {
                    case PAYROLL_TYPE_ADP:
                        return <>
                            <ThirdTitle>Unique Account Identifier:</ThirdTitle>
                            <Spacer bottom={1}/>
                            <Text>{payroll.credentials.unique_identifier}</Text>
                        </>

                    case PAYROLL_TYPE_PAYCOM:
                        return <>
                            <ThirdTitle>Client ID:</ThirdTitle>
                            <Spacer bottom={1}/>
                            <Text>{payroll.credentials.username}</Text>
                        </>

                    case PAYROLL_TYPE_UZIO:
                        return (
                            <>
                                <ThirdTitle>Uzio API Key:</ThirdTitle>
                                <Spacer bottom={1} />
                                <Text>
                                    {payroll.credentials.api_key
                                        ? `••••${payroll.credentials.api_key.slice(-4)}`
                                        : "Not configured"}
                                </Text>
                                {payroll.credentials.company_id && (
                                    <>
                                        <Spacer bottom={1} />
                                        <Text>Company ID: {payroll.credentials.company_id}</Text>
                                    </>
                                )}
                            </>
                        );
                }
            })()}
        </Card>
    )
}